
export class ChartImagesResponseDTO {
  responsePosition: number;
  key: string;
}
